(function () {
  var COOKIE = 'omni_geo_region';
  var TTL_HOURS = 24;
  var html = document.documentElement;

  var US_STATE_NAME_TO_CODE = {
    alabama: 'AL', alaska: 'AK', arizona: 'AZ', arkansas: 'AR',
    california: 'CA', colorado: 'CO', connecticut: 'CT', delaware: 'DE',
    'district of columbia': 'DC', florida: 'FL', georgia: 'GA',
    hawaii: 'HI', idaho: 'ID', illinois: 'IL', indiana: 'IN',
    iowa: 'IA', kansas: 'KS', kentucky: 'KY', louisiana: 'LA',
    maine: 'ME', maryland: 'MD', massachusetts: 'MA', michigan: 'MI',
    minnesota: 'MN', mississippi: 'MS', missouri: 'MO', montana: 'MT',
    nebraska: 'NE', nevada: 'NV', 'new hampshire': 'NH', 'new jersey': 'NJ',
    'new mexico': 'NM', 'new york': 'NY', 'north carolina': 'NC',
    'north dakota': 'ND', ohio: 'OH', oklahoma: 'OK', oregon: 'OR',
    pennsylvania: 'PA', 'rhode island': 'RI', 'south carolina': 'SC',
    'south dakota': 'SD', tennessee: 'TN', texas: 'TX', utah: 'UT',
    vermont: 'VT', virginia: 'VA', washington: 'WA', 'west virginia': 'WV',
    wisconsin: 'WI', wyoming: 'WY'
  };

  function setAttr(region) {
    html.setAttribute('data-geo-region', region);
    html.setAttribute('data-geo-ready', 'true');
    pruneGeoElements(region);
    html.dispatchEvent(new CustomEvent('geo:ready', { detail: { region: region } }));
  }

  function pruneGeoElements(region) {
    var isCA = region === 'US-CA';
    var toRemove = document.querySelectorAll(isCA ? '.geo-hide-us-ca' : '.geo-show-us-ca');
    for (var i = 0; i < toRemove.length; i++) {
      toRemove[i].remove();
    }
  }

  function setCookie(value, hours) {
    var expires = new Date(Date.now() + hours * 3600 * 1000).toUTCString();
    document.cookie = COOKIE + '=' + encodeURIComponent(value) +
      '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(^|; )' + name + '=([^;]+)'));
    return m ? decodeURIComponent(m[2]) : null;
  }

  function normalize(data) {
    if (!data || !data.country_code) return 'UNKNOWN';
    if (data.country_code === 'US') {
      var stateCode = US_STATE_NAME_TO_CODE[(data.region || '').toLowerCase()];
      return stateCode ? 'US-' + stateCode : 'US-XX';
    }
    return data.country_code;
  }

  var cached = getCookie(COOKIE);
  if (cached) { setAttr(cached); return; }

  fetch('https://get.geojs.io/v1/ip/geo.json')
    .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
    .then(function (data) {
      var region = normalize(data);
      setCookie(region, TTL_HOURS);
      setAttr(region);
    })
    .catch(function () { setAttr('UNKNOWN'); });
})();
